import { ResourceAllowOrderForm } from "@/common/enums";
import { ResourceInfo } from "../resource-service";
import { HttpResponse, SearchResponse } from "@/fetchInterceptor/AxiosMethod";
import { ExternalBookingResponse, CreateExternalTempReservationResponse, CheckExternalResourcesResponse } from "./entity/response";
import { OrderDataRequest } from "./entity/OrderDataRequest";

export const TokenIRcResourceService = "IRcResourceService";

export interface IRcResourceService {
  getStatusAllowOrderForm(resource: ResourceInfo, originalSelectedResources: ResourceInfo[]): ResourceAllowOrderForm;
  fetchExternalBookingResources(payload: OrderDataRequest): Promise<SearchResponse<ExternalBookingResponse>>;
  fetchCreateExternalTempReservation(request: OrderDataRequest): Promise<HttpResponse<CreateExternalTempReservationResponse>>;
  fetchCheckExternalResourcesSuitableForMovingOrder(request: OrderDataRequest): Promise<HttpResponse<CheckExternalResourcesResponse>>;
  fetchCheckResource(request: OrderDataRequest): Promise<HttpResponse<any>>;
}
